import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Check, Loader2, Compass, ArrowRight, Award } from "lucide-react";
import AppShell from "@/components/AppShell";
import client from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Life() {
  const nav = useNavigate();
  const { t } = useLang();
  const [missions, setMissions] = useState(null);
  useEffect(() => { client.get("/learn/life").then(({ data }) => setMissions(data)).catch(() => setMissions([])); }, []);
  return (
    <AppShell>
      <div className="pt-10 pb-1">
        <div className="flex items-center gap-2"><Compass className="text-[#2563EB]" /><h1 className="font-heading text-2xl font-extrabold tracking-tight text-[#0F172A]">MELLETIC Life</h1></div>
        <p className="text-slate-500 mt-1 text-sm">{t("life_sub")}</p>
      </div>
      {!missions ? <div className="pt-20 flex justify-center"><Loader2 className="animate-spin text-[#2563EB]" /></div> : (
        missions.length === 0 ? <p className="pt-16 text-center text-slate-400">Missions unlock as you learn. Keep going!</p> : (
          <div className="mt-4 space-y-4">
            {missions.map((m) => (
              <button key={m.id} disabled={!m.unlocked} onClick={() => nav(`/life/${m.id}`)} data-testid={`life-mission-${m.id}`}
                className={`w-full text-left rounded-[24px] overflow-hidden shadow-[0_18px_40px_-24px_rgba(15,23,42,0.42)] ${m.is_final ? "border-2 border-amber-300" : "border border-slate-200/70"} ${m.unlocked ? "bg-white active:scale-[0.99] transition-transform" : "bg-slate-50"}`}>
                <div className="relative h-40 bg-[#E0F2FE]">
                  <img src={m.cover} alt="" className={`w-full h-full object-cover object-center ${m.unlocked ? "" : "grayscale opacity-60"}`} />
                  <div className="absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-white to-transparent" />
                  <span className="absolute top-3 left-3 text-[10px] font-extrabold text-[#2563EB] bg-white rounded-full px-2 py-0.5 shadow-sm">{m.level}</span>
                  {m.is_final && <span className="absolute top-3 left-12 text-[10px] font-extrabold text-amber-900 bg-gradient-to-r from-amber-300 to-yellow-200 rounded-full px-2 py-0.5 shadow-sm flex items-center gap-1"><Award size={11} /> FINAL</span>}
                  {m.status === "completed" && <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-[#22C55E] text-white flex items-center justify-center shadow-sm"><Check size={16} /></span>}
                  {!m.unlocked && <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white text-slate-400 flex items-center justify-center shadow-sm"><Lock size={14} /></span>}
                </div>
                <div className="p-4">
                  <p className={`text-[11px] font-extrabold uppercase tracking-[0.14em] ${m.is_final ? "text-amber-600" : "text-[#2563EB]"}`}>{m.is_final ? t("life_final_journey") : t("life_mission")}</p>
                  <h2 className="font-heading text-lg font-extrabold text-[#0F172A] mt-1">{m.title}</h2>
                  {m.subtitle && <p className="text-sm text-[#475569] mt-0.5">{m.subtitle}</p>}
                  {m.description && <p className="text-sm text-[#475569] mt-2 line-clamp-2">{m.description}</p>}
                  {m.unlocked && (
                    <div className="mt-3 flex items-center gap-1.5 text-sm font-bold text-[#2563EB]">
                      {m.status === "completed" ? t("life_play_again") : t("life_start_mission")} <ArrowRight size={16} />
                    </div>
                  )}
                  {!m.unlocked && <div className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-slate-400"><Lock size={13} /> {t("life_locked")}</div>}
                </div>
              </button>
            ))}
          </div>
        )
      )}
    </AppShell>
  );
}
